import { render } from "./OffcanvasSettingBranch.vue?vue&type=template&id=9ed8ef92"
import script from "./OffcanvasSettingBranch.vue?vue&type=script&lang=js"
export * from "./OffcanvasSettingBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__